import { getPath } from "lib/lodash";

export const hasTeamFoldersSelector = state =>
  getPath(state, "api.folders.team.pages.1.ids.length", 0) >= 1;

export const teamFoldersApiPageSelector = (state, page) => {
  return state.api.folders.team.pages[page];
};
